import { OpenSpace } from "src/app/entities/openSpace";
import {
  Component,
  OnInit,
  Injectable,
  OnDestroy,
  AfterViewInit,
} from "@angular/core";
import { Proposal } from "src/app/entities/proposal";
import { OpenSpaceService } from "src/app/services/open-space.service";
import { ProposalService } from "src/app/services/proposal-service";
import { StorageMap } from "@ngx-pwa/local-storage";
import { Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { ProposalComponent } from "../proposal/proposal.component";
import { Category } from "src/app/entities/category";
import { TemplateService } from "src/app/services/template.service";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import {DatePipe} from "@angular/common";
import { NotifierService } from "src/app/services/notifier.service";
import { HttpClient } from "@angular/common/http";


@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
@Injectable()
export class DashboardComponent implements OnInit, OnDestroy {
  constructor(
    private storage: StorageMap,
    private openService: OpenSpaceService,
    private proposalService: ProposalService,
    private dialog: MatDialog,
    private templateService: TemplateService,
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe,
    private notifier: NotifierService,
    private http: HttpClient
  ) {}

  openSpaceId: number;
  proposals: Proposal[];
  categories: Category[];
  content: string;
  dataSubscription: Subscription;
  openSpace: OpenSpace;
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  today: any;
  votingEndDate: any;

  ngOnInit() {
    this.loadcontent();
  }

  loadcontent() {
    this.dataSubscription = this.storage
      .watch("selectedOpenId", { type: "string" })
      .subscribe((openId) => {
        const openIdInt = parseInt(openId, 10);
        if (!isNaN(openIdInt)) {
          this.openSpaceId = openIdInt;
          this.getOpenSpaceProposals(this.openSpaceId);
          this.getOpenSpace();
        }
      });
  }

  getCategoryTemplate() {
    this.templateService
      .getCategoryTemplate(this.openSpace.categoryTemplateId)
      .subscribe(
        (data) => {
          if (data) {
            this.categories = data.categoryTemplates[0]?.categories;
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  getOpenSpace() {
    if (this.openSpaceId) {
      this.openService.getOpenSpace(this.openSpaceId).subscribe(
          (data) => {
            this.openSpace = data.OpenSpaces[0];
            this.notifier.deadLineNotifications(this.openSpace);

            this.getCategoryTemplate();
          },
          (error) => {
            console.error(error);
          }
      );
    }
  }

  ngOnDestroy() {
    this.dataSubscription.unsubscribe();
  }

  getOpenSpaceProposals(openSpaceId: number) {
    this.proposalService.getOpenSpaceProposals(openSpaceId).subscribe(
      (data) => {
        this.content = data;
        this.proposals = JSON.parse(this.content).Proposals;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getColor(i: number) {
    return i.toString().substring(i.toString().length - 1);
  }


  addProposal() {
    const dialogRef = this.dialog.open(ProposalComponent, {
      data: { createMode: true, categories: this.categories },
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        const proposalCreated =
          "true" === JSON.stringify(result?.proposalNewData);
        if (proposalCreated) {
          this.getOpenSpaceProposals(this.openSpaceId);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  reLoadProposals() {
    this.getOpenSpaceProposals(this.openSpaceId);
  }
}
